import React from 'react';
import Hero from '../components/Hero';
import ProofBar from '../components/ProofBar';
import Features from '../components/Features';
import Philosophy from '../components/Philosophy';
import Protocol from '../components/Protocol';
import Showcase from '../components/Showcase';
import ProductTestimonials from '../components/ProductTestimonials';
import Testimonials from '../components/Testimonials';
import PricingTeaser from '../components/PricingTeaser';

const Home = () => {
    return (
        <>
            {/* 1. Opening Shot — customer desire, guide's pitch */}
            <Hero />
            {/* 2. Trust Bar — immediate authority proof, closes Trust objection */}
            <ProofBar />
            {/* 3. Features — outcome-first, closes 'Will it work for me?' */}
            <Features />
            {/* 4. Philosophy — names the villain (the cloud), guide's manifesto */}
            <Philosophy />
            {/* 5. Protocol — 3-step plan, makes action feel safe */}
            <Protocol />
            {/* 6. Showcase — product imagery and hardware */}
            <Showcase />
            {/* 7a. Product Testimonials — RoofClaw client receipts (Bryan, Berenice, Andrew) */}
            <ProductTestimonials />
            {/* 7b. Adam Testimonials — endorsements of Adam as consultant/innovator */}
            <Testimonials />
            {/* 8. Pricing Teaser — two ways in, routes to /pricing */}
            <PricingTeaser />
        </>
    );
};

export default Home;
